module.exports = __webpack_public_path__ + "static/media/CeciliaPortada.38599265.jpeg";